export default __webpack_public_path__ + "static/media/heads-10.a8ce06f3.svg";